<template>
	<search-bar
		:ctas="ctas"
		:show-geo-location="true"
		@browse="compare()"/>
</template>
<script>
	export default {
		methods: {
			compare() {
				this.$scrollTo('.packages .gradient');
			}
		},
		data() {
			return {
				ctas: [
					{
						label: 'Browse Packages',
						cssClass: 'btn secondary',
						event: 'browse'
					},
					{
						label: 'Check Coverage',
						cssClass: 'btn primary',
						event: 'checkCoverage'
					},
				],
			}
		},
		mounted() {
			if(this.$store && window._providers) {
				this.$store.commit('providers/updateProviders', window._providers);
			}
		}
	}
</script>
<style lang="scss" scoped>
	.search-bar::v-deep {
		max-width: 74rem;
		margin-top: 3rem;
		margin-bottom: 3.5rem;

		.search-bar-ctas {
			display: flex;
			align-content: center;
			align-items: center;
			justify-content: center;

			button {
				width: 23rem;
				padding: 0.5rem 0;
				border-radius: 2.8rem;

				&:nth-child(2) {
					margin-left: 2rem;
				}
			}
		}
	}
</style>
